import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography, TextField, Button } from '@mui/material';
import FormErrors from '../../components/FormErrors';
import { confirmLoginCode, Flows } from '../../lib/allauth';
import { Navigate } from 'react-router-dom';
import { useAuthStatus } from '../../auth';
import BackgroundContainer from '../../components/BackgroundContainer';
import BaseHeader from '../../components/BaseHeader';
import BaseButton from '../../components/BaseButton';
import BaseTextField from '../../components/BaseTextField';
import BaseFormContainer from '../../components/BaseFormContainer';


const Subtitle = styled(Typography)({
  fontFamily: 'Playfair Display, serif',
  fontSize: '1.5rem',
  color: '#ffbfe1',
  textAlign: 'center',
  textShadow: '0px 2px 6px rgba(0, 0, 0, 0.5)',
  lineHeight: '1.4',
});

export default function ConfirmLoginCode() {
  const [, authInfo] = useAuthStatus();
  const [code, setCode] = useState('');
  const [response, setResponse] = useState({ fetching: false, content: null });

  function submit() {
    setResponse({ ...response, fetching: true });
    confirmLoginCode(code)
      .then((content) => setResponse((r) => ({ ...r, content })))
      .catch((e) => {
        console.error(e);
        window.alert(e);
      })
      .finally(() => setResponse((r) => ({ ...r, fetching: false })));
  }

  if (response.content?.status === 409 || authInfo.pendingFlow?.id !== Flows.LOGIN_BY_CODE) {
    return <Navigate to='/account/login/code' />;
  }

  return (
    <BackgroundContainer>
      <BaseFormContainer>
        <BaseHeader sx={{ fontSize: '2rem' }} >Enter Sign-In Code</BaseHeader>
        <Subtitle sx={{
          marginBottom: '20px',
          fontSize: '1.2rem',
          '@media (max-width: 400px)': {
            fontSize: '1.1rem',
          },
          '@media (max-width: 360px)': {
            fontSize: '1rem',
          },
          '@media (max-width: 320px)': {
            fontSize: '0.95rem',
          },
        }}>
          The code expires shortly, so please enter it soon.
        </Subtitle>
        <FormErrors errors={response.content?.errors} />
        <BaseTextField
          label="Code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          type="text"
          required
        />
        <BaseButton disabled={response.fetching} onClick={submit}>
          Sign In
        </BaseButton>
      </BaseFormContainer>
    </BackgroundContainer>
  );
}